import {
  privateFetch
} from "apis";
import {
  rmCachedBusinessPhoneNumber
} from "./appifyActions";
import {
  rmActiveAppPhoneNumber
} from "./activeApp";

// business dispatchers
export const resetBusiness = () => ({
  type: 'RESET_BUSINESS'
});

export const setBusiness = business => ({
  type: 'SET_BUSINESS',
  business
});

export const setBusinessUserId = userId => ({
  type: 'SET_BUSINESS_USERID',
  userId
});

export const updateBusiness = (key, value) => ({
  type: 'UPDATE_BUSINESS',
  key,
  value
});

export const updateBusinessLocation = (locationIdx, key, value) => ({
  type: 'UPDATE_BUSINESS_LOCATION',
  locationIdx, 
  key, 
  value
});

export const updateBusinessPhoneNumber = (locationIdx, phoneIdx, key, value) => ({
  type: 'UPDATE_BUSINESS_PHONENUMBER',
  locationIdx, 
  phoneIdx, 
  key, 
  value
});

export const updateBusinessHours = (locationIdx, hourIdx, value) => ({
  type: 'UPDATE_BUSINESS_HOURS',
  locationIdx, 
  hourIdx,
  value
});

export const addBusinessLocation = () => ({
  type: 'ADD_BUSINESS_LOCATION'
});

export const addBusinessPhoneNumber = locationIdx => ({
  type: 'ADD_BUSINESS_PHONENUMBER',
  locationIdx
});

export const removeBusinessLocation = locationIdx => ({
  type: 'REMOVE_BUSINESS_LOCATION',
  locationIdx
});

export const rmBusinessPhoneNumber = (locationIdx, phoneIdx) => ({
  type: 'REMOVE_BUSINESS_PHONENUMBER',
  locationIdx,
  phoneIdx
});

export const removeBusinessPhoneNumber = (locationIdx, phoneIdx, phoneId, appId) => dispatch => {
  dispatch(rmBusinessPhoneNumber(locationIdx, phoneIdx));
};

export const putBusiness = (business) => {
  const url = __BASE_API_URL__ + `/business/${business.id}`;
  return new Promise((resolve, reject) => {
    return privateFetch(url, {
      method: 'PUT',
      body: JSON.stringify(business)
    })
    .then(newBusiness => {
      resolve(newBusiness);
    }).catch(error => {
      reject(error);
    });  
  });
};

export const postBusiness = business => {
  return new Promise((resolve, reject) => {
    return privateFetch(`${__BASE_API_URL__}/business`, {
        method: 'POST',
        body: JSON.stringify(business)
      })
      .then(newBusiness => {
        resolve(newBusiness);
      }).catch(err => {
        reject(err);
      });
  });
};

